<template>
  <div>
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <h4>Alerts</h4>
            </b-col>
            <b-col>
              <b-button variant="outline-secondary" class="float-right" @click="refreshAlerts" :disabled="isLoading">
                <b-spinner small v-if="isLoading"/>
                <feather v-else type="refresh-cw"/>
              </b-button>
            </b-col>
          </b-row>
          <div v-if="isLoading" class="loading-screen">
            <b-spinner large></b-spinner>
          </div>
          <div v-if="!isLoading && total == 0">
            <b-alert show variant="info">
              No alerts were found
            </b-alert>
          </div>
          <b-table
            v-if="!isLoading && total > 0"
            striped
            hover
            :items="alerts"
            :fields="fields"
            class="mt-3">
            <template #cell(client_name)="data">
              <span>{{ data.item.client.display_name || '-' }}</span>
            </template>
            <template #cell(created_at)="data">
              <span>{{ formatDate(data.item.created_at) || '-' }}</span>
            </template>
            <template #cell(alert_reason)="data">
              <span>{{ buildAlertReason(data.item.alert_type.key) || '-' }}</span>
            </template>
            <template #cell(unit)="data">
              <span>{{ data.item.unit || '-' }}</span>
            </template>
            <template #cell(implementation_status)="data">
              <span>{{ data.item.implementation_status || '-' }}</span>
            </template>
            <template #cell(description)="data">
              <span>{{ data.item.alert_type.description || '-' }}</span>
            </template>
            <template #cell(actions)="data">
              <b-button
                v-if="data.item.client.id"
                variant="outline-primary"
                size="sm"
                @click="navigateToClientPage(data.item.client.id)">
                <feather type="edit"/>
              </b-button>
            </template>
          </b-table>
          <b-pagination
            v-if="!isLoading && total > pageSize"
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            @change="onPageChange"
            class="mt-3 d-flex justify-content-center">
          </b-pagination>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  data() {
    return {
      isLoading: false,
      alerts: [],
      fields: [
        { key: 'client_name', label: 'Client Name' },
        { key: 'created_at', label: 'Created At' },
        { key: 'alert_reason', label: 'Alert Reason' },
        { key: 'unit', label: 'Unit' },
        { key: 'implementation_status', label: 'Imp. Status' },
        { key: 'description', label: 'Description' },
        { key: 'actions', label: 'Actions', class: 'text-center' },
      ],
      reasons: {
        no_conditions_enabled: 'No conditions enabled',
        no_professionals_available: 'No professionals available',
        unit_not_enabled: 'Unit not enabled',
      },
      pageSize: 10,
      currentPage: 1,
      total: 0,
    };
  },
  methods: {
    async refreshAlerts() {
      this.currentPage = 1;
      this.fetchAlerts();
    },
    async fetchAlerts() {
      this.isLoading = true;
      try {
        const offset = (this.currentPage - 1) * this.pageSize;
        const response = await axios.get('v1/clients/alerts', {
          params: {
            limit: this.pageSize,
            offset,
          },
        });

        this.alerts = response.data.data;
        this.total = response.data.total || 0;
      } catch (error) {
        console.error(error);
        this.$noty.error('Failed to load alerts');
      } finally {
        this.isLoading = false;
      }
    },
    navigateToClientPage(clientId) {
      if (clientId) {
        this.$router.push(`/onboarding/client/edit/${clientId}`);
      } else {
        this.$noty.error('Client ID is missing for this alert');
      }
    },
    buildAlertReason(key) {
      return this.reasons[key] || key;
    },
    formatDate(date) {
      return date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : '-';
    },
    onPageChange(page) {
      this.currentPage = page;
      this.fetchAlerts();
    },
  },
  created() {
    this.fetchAlerts();
  },
};
</script>

<style scoped>
.table-container {
  padding: 20px;
}

.loading-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 100%;
}
</style>
